// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 96 ? "vendors" : chunkId) + "." + {"96":"20aacb","818":"41d7b4"}[chunkId] + ".js";
};